module.exports = __webpack_public_path__ + "static/media/317.8c72a1a1.svg";